module.exports = __webpack_public_path__ + "Poppins-Medium.a4e11dda40531debd374.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/poppins/Poppins-Medium.ttf
// module id = ../../../../../src/assets/fonts/poppins/Poppins-Medium.ttf
// module chunks = main